<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_anchor_point" | translate }}
            <span
                class="color-light sp-icon icon-info-bold small"
                tooltip="{{ 'anchor_point_hint' | translate }}"
            ></span>
        </label>
        <div class="col-xs-6">
            <select class="form-control input-sm mb-5" (change)="onPositionHorizontalChange($any($event.target).value)">
                <option value="left" [selected]="positionHorizontal() === 'left'">
                    {{ "option_animation_position_left" | translate }}
                </option>
                <option value="right" [selected]="positionHorizontal() === 'right'">
                    {{ "option_animation_position_right" | translate }}
                </option>
            </select>
            <select class="form-control input-sm" (change)="onPositionVerticalChange($any($event.target).value)">
                <option value="top" [selected]="positionVertical() === 'top'">
                    {{ "option_animation_position_top" | translate }}
                </option>
                <option value="bottom" [selected]="positionVertical() === 'bottom'">
                    {{ "option_animation_position_bottom" | translate }}
                </option>
            </select>
        </div>
        <div class="col-xs-6">
            <div class="form-control position-control">
                <div
                    [class.selected]="positionVertical() === 'top'"
                    class="position-btn vertical-btn"
                    (click)="onPositionVerticalChange('top')"
                ></div>
                <div class="elements-row">
                    <div
                        [class.selected]="positionHorizontal() === 'left'"
                        class="position-btn horizontal-btn"
                        (click)="onPositionHorizontalChange('left')"
                    ></div>
                    <div class="widget-example"></div>
                    <div
                        [class.selected]="positionHorizontal() === 'right'"
                        class="position-btn horizontal-btn"
                        (click)="onPositionHorizontalChange('right')"
                    ></div>
                </div>
                <div
                    [class.selected]="positionVertical() === 'bottom'"
                    class="position-btn vertical-btn"
                    (click)="onPositionVerticalChange('bottom')"
                ></div>
            </div>
        </div>
    </div>

    <div class="form-group mb-10">
        <label class="col-xs-12">
            <span [tooltip]="'beta_test_hint' | translate"
                >{{ "control_postiton" | translate }} <sup class="color-danger">β</sup></span
            >
        </label>

        <label class="col-xs-12">
            <span>{{ "control_alignment" | translate }}</span>
        </label>

        <div class="col-xs-12 mb-10">
            <div class="btn-group btn-group-justified btn-group-with-tooltip btn-group-six" data-toggle="buttons">
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-left"
                        style="transform: scaleY(-1)"
                        (click)="setWidgetHorizontalPosition('left')"
                    ></span>
                </button>
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-center"
                        style="transform: scaleY(-1)"
                        (click)="setWidgetHorizontalPosition('center')"
                    ></span>
                </button>
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-right"
                        style="transform: scaleY(-1)"
                        (click)="setWidgetHorizontalPosition('right')"
                    ></span>
                </button>
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-left"
                        style="transform: scaleX(-1) rotate(90deg)"
                        (click)="setWidgetVerticalPosition('top')"
                    ></span>
                </button>
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-center"
                        style="transform: rotate(90deg)"
                        (click)="setWidgetVerticalPosition('center')"
                    ></span>
                </button>
                <button class="btn btn-grey">
                    <span
                        class="sp-icon icon-aling-right"
                        style="transform: scaleX(-1) rotate(90deg)"
                        (click)="setWidgetVerticalPosition('bottom')"
                    ></span>
                </button>
            </div>
        </div>

        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="X"
                    suffixText="px"
                    [value]="xValue()"
                    (valueChange)="onXChange($event)"
                ></sp-input-num>
            </div>
        </div>

        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Y"
                    suffixText="px"
                    [value]="yValue()"
                    (valueChange)="onYChange($event)"
                ></sp-input-num>
            </div>
        </div>
    </div>

    <div class="form-group mb-10">
        <label class="col-xs-12">
            <span>{{ "control_arrangement" | translate }}</span>
        </label>

        <div class="col-xs-12">
            <div class="btn-group btn-group-justified btn-group-with-tooltip btn-group-four" data-toggle="buttons">
                <button class="btn btn-grey" (click)="onZIndexChange(5)">
                    <img src="./assets/img/lpc-forward-icon.svg" alt="forward" />
                </button>
                <button class="btn btn-grey" (click)="onZIndexChange(2)">
                    <img src="./assets/img/lpc-backward-icon.svg" alt="backward" />
                </button>
                <button class="btn btn-grey" (click)="onZIndexChange(10)">
                    <img src="./assets/img/lpc-front-icon.svg" alt="front" />
                </button>
                <button class="btn btn-grey" (click)="onZIndexChange(1)">
                    <img src="./assets/img/lpc-back-icon.svg" alt="back" />
                </button>
            </div>
        </div>
    </div>

    <div class="form-group mb-20">
        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Z-index"
                    [max]="10"
                    [min]="0"
                    [value]="zIndexValue()"
                    (valueChange)="onZIndexChange($event)"
                ></sp-input-num>
            </div>
        </div>

        <div class="col-xs-6">
            <div>
                <sp-input-num
                    prefixText="Rot.°"
                    [value]="rotateValue()"
                    (valueChange)="onRotateChange($event)"
                ></sp-input-num>
            </div>
        </div>
    </div>

    @if (showHeight() || showWidth()) {
        <div class="form-group mb-20">
            @if (showWidth()) {
                <div [class.col-xs-6]="showHeight()" [class.col-xs-12]="!showHeight()">
                    <label>
                        <span [tooltip]="'beta_test_hint' | translate"
                            >{{ "control_width" | translate }} <sup class="color-danger">β</sup></span
                        >
                        <small
                            [tooltip]="'widget_width_hint' | translate"
                            class="sp-icon icon-info-bold color-light"
                            style="margin-left: 5px"
                        ></small>
                    </label>
                    <div>
                        <sp-input-num
                            suffixText="px"
                            [value]="widthValue()"
                            (valueChange)="onWidthChange($event)"
                        ></sp-input-num>
                    </div>
                </div>
            }
            @if (showHeight()) {
                <div [class.col-xs-6]="showWidth()" [class.col-xs-12]="!showWidth()">
                    <label>
                        <span [tooltip]="'beta_test_hint' | translate"
                            >{{ "control_height" | translate }} <sup class="color-danger">β</sup></span
                        >
                        <small
                            [tooltip]="'widget_width_hint' | translate"
                            class="sp-icon icon-info-bold color-light"
                            style="margin-left: 5px"
                        ></small>
                    </label>
                    <div>
                        <sp-input-num
                            suffixText="px"
                            [value]="heightValue()"
                            (valueChange)="onHeightChange($event)"
                        ></sp-input-num>
                    </div>
                </div>
            }
        </div>
    }
</div>
